import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} anonyymin chatin etusivu`,
    languageButtonLabel: `Kieli`,
    languageModalTitle: `Valitse kieli`,
    languageModalCloseLabel: `Sulje kielivalikko`,
  },
  languageOptions: {
    'en-US': {
      label: `Englanti (Yhdysvallat)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Englanti (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Englanti (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Englanti (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugali (Portugali)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugali (Brasilia)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Saksa (Saksa)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Saksa (Itävalta)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Saksa (Sveitsi)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Espanja (Espanja)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Ranska (Ranska)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italia (Italia)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Hollanti (Alankomaat)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Puola (Puola)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Ruotsi (Ruotsi)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Tanska (Tanska)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi (Suomi)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norja (Norja)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islanti (Islanti)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japani (Japani)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Korea (Etelä-Korea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Kiina (Kiina)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantoninkiina (Hongkong – Kiinan erityishallintoalue)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnam (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai (Thaimaa)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesia (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenia)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (Intia)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (Intia)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (Intia)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persia (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Pandžabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigerianpidgin (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Venäjä (Venäjä)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabia (Saudi-Arabia)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabia (Arabiemiirikunnat)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabia (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marokonarabia (Marokko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turkki (Turkki)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Valitse kieli`,
    closeLabel: `Sulje kielivalikko`,
  },
  languageHint: (ctx) => `Vaihda ${ctx.localesCount}+ kieliversioon ilman tiliä.`,
  readPagePrompt: ({languageLabel}) => `Lue tämä sivu kielellä ${languageLabel}.`,
};
